module.exports = __webpack_public_path__ + "static/media/l2e-screenshot.61f440f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/l2e-screenshot.png
// module id = 575
// module chunks = 0